import React from 'react'
import { useForm, FormProvider } from 'react-hook-form'

import {
  Card,
} from 'components'
import { SPACING } from 'utils'
import {
  IGetAllPaginatedParams,
} from 'services/NGT/Log'
import { yupResolver } from 'utils/yup'

import Form from './components/Form'
import Table from './components/Table'
import { DEFAULT_FORM_VALUES, VALIDATION_SCHEMA } from './default'

const LogList: React.FC = () => {
  const formMethods = useForm<IGetAllPaginatedParams>({
    defaultValues: DEFAULT_FORM_VALUES,
    resolver: yupResolver(VALIDATION_SCHEMA)
  })

  return (
    <Card
      marginLeft={SPACING.spacing20}
      marginRight={SPACING.spacing20}
      marginBottom={SPACING.spacing100}
      padding={SPACING.spacing20}
      boxShadow={`0px -1px 32px rgba(50, 50, 71, 0.12), 0px 24px 32px rgba(50, 50, 71, 0.12)`}
      borderRadius={`0px 10px 0px 0px`}
    >
      <FormProvider {...formMethods}> 
        <Form />
        <Table />
      </FormProvider>
    </Card>
  )
}

export default LogList
